import React from "react";
import { ElementorIntegrationPageStyled } from "./styled";
import { Table, Layout, Typography } from "antd";
import { observer, inject } from "mobx-react";
import { observable, action } from "mobx";
import Api from "../../../services/Api";

type Props = {
  api?: Api;
};

const { Header } = Layout;
const { Title } = Typography;

const columns = [
  {
    title: "Template name",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "Shortcode",
    key: "id",
    render: (...args:any) => {
      return `[wpmailer template_id=${args[1].id}]`;
    }
  }
];

@inject("api")
@observer
class ElementorIntegrationPage extends React.PureComponent<Props, any> {
  @observable loading: boolean = false;
  @observable templates: any[] = [];

  @action setTemplates = (templates: any[]) => {
    this.templates = templates;
  };

  componentDidMount = () => {
    this.fetchInitData();
  };

  fetchInitData = async () => {
    this.loading = true;
    const response: any = await this.props.api?.getTemplates(0, 10000000);

    if (response.data.templates) {
      this.setTemplates(response.data.templates);
    }

    this.loading = false;
  };

  render() {
    return (
      <ElementorIntegrationPageStyled>
        <Header style={{ background: "#fff", padding: "0", height: "inherit" }}>
          <Title level={3}>Elementor</Title>
          <Title level={4} style={{ color: "#a7a7a7", margin: "0 0 38px" }}>
            To set custom template in elementor form , go to form widget and in
            message section paste the [wpmailer template=ID]
          </Title>
        </Header>
        <Table
          dataSource={this.templates}
          columns={columns}
          bordered
          loading={this.loading}
        />
        ;
      </ElementorIntegrationPageStyled>
    );
  }
}
export default ElementorIntegrationPage;
